import { deleteSessionsBulk, deleteSingle, patchSingle, postSingle, putSingle } from '@/helper/apicalls';

import { baseURL } from './const';

// eslint-disable-next-line sonarjs/cognitive-complexity
export async function singleAction({ request, params }: any) {
  const body = Object.fromEntries(await request.formData());
  const redirectTo = body.redirectTo;
  delete body.redirectTo;

  if (body.companyId) body.companyId = JSON.parse(body.companyId);
  if (body.contactId) body.contactId = JSON.parse(body.contactId);
  if (body.projectId) body.projectId = JSON.parse(body.projectId);
  if (body.mixerId) body.mixerId = JSON.parse(body.mixerId);
  if (body.assistantIds) body.assistantIds = JSON.parse(body.assistantIds);
  if (body.prePadHours) body.prePadHours = JSON.parse(body.prePadHours);
  if (body.postPadHours) body.postPadHours = JSON.parse(body.postPadHours);
  if (body.roomId) body.roomId = JSON.parse(body.roomId);
  if (body.ids) {
    body.sessionIds = JSON.parse(body.ids);
    delete body.ids;
  }
  if (body.sessionIds && typeof body.sessionIds === 'string') body.sessionIds = JSON.parse(body.sessionIds);

  if (request.method === 'PATCH') {
    if ('unsupervised' in body) {
      body.unsupervised = body.unsupervised === 'on' || body.unsupervised === 'true' || body.unsupervised === true;
    }
    if ('noCharge' in body) {
      body.noCharge = body.noCharge === 'on' || body.noCharge === 'true' || body.noCharge === true;
    }
    if ('pastMidnight' in body) {
      body.pastMidnight = body.pastMidnight === 'on' || body.pastMidnight === 'true' || body.pastMidnight === true;
    }
  } else {
    body.unsupervised = body.unsupervised == 'on' ? true : false;
    body.noCharge = body.noCharge == 'on' ? true : false;
  }

  if (request.method == 'POST') {
    return postSingle(baseURL, body);
  } else if (request.method == 'PUT') {
    return putSingle(baseURL, params.id, body);
  } else if (request.method == 'PATCH') {
    return patchSingle(baseURL, 'bulk', body);
  } else if (request.method == 'DELETE') {
    if (Array.isArray(body.sessionIds) && body.sessionIds.length > 0) {
      return deleteSessionsBulk(body.sessionIds);
    }
    if (!params.id) return 'No sessions were selected.';
    return deleteSingle(baseURL, params.id, redirectTo);
  } else {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }
}

export async function holidayAction({ request, params }: any) {
  const body = Object.fromEntries(await request.formData());

  const url = '/holiday';

  if (request.method == 'POST') {
    return postSingle(url, body);
  } else if (request.method == 'PUT') {
    return putSingle(url, params.id, body);
  } else if (request.method == 'DELETE') {
    return deleteSingle(url, params.id);
  } else {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }
}
